import {
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
} from '@chakra-ui/react';
import { SessionReminderModal } from '@web-app/components/SessionReminderModal';
import { Button } from '@web-app/components/ui/Button/button';
import React, { useEffect, useRef } from 'react';

export const AetnaSessionLimitModal = (): JSX.Element | null => {
  const { isOpen, onOpen, onClose } = useDisclosure();
  const initialFocusRef = useRef<HTMLElement>(null);

  // Auto-open the modal when component mounts
  useEffect(() => {
    onOpen();
  }, [onOpen]);

  return (
    <SessionReminderModal
      popupId="aetna-session-limit-reminder"
      isOpen={isOpen}
      onClose={onClose}
      size="md"
      initialFocusRef={initialFocusRef}
    >
      <ModalOverlay />
      <ModalContent
        ref={initialFocusRef as React.Ref<HTMLElement>}
        tabIndex={-1}
        sx={{ outline: 'none' }}
        bg="bg.default"
        color="text.default"
      >
        <ModalHeader>Aetna Session Limit</ModalHeader>

        <ModalBody>
          Aetna sessions (including initials) are limited to 60 minutes. Time
          spent beyond 60 minutes is not billable.
        </ModalBody>

        <ModalFooter>
          <Button
            onClick={onClose}
            className="w-full bg-primary-legacy text-primary-foreground hover:bg-primary-legacy/90"
          >
            Got it!
          </Button>
        </ModalFooter>
      </ModalContent>
    </SessionReminderModal>
  );
};
